import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'




export const projectsData = [
    {
        id: 1,
        projectName: 'Banking Application',
        projectDesc: 'A banking application that allows users to create accounts, deposit and withdraw money, and view transaction history.',
        tags: ['Java', 'Spring Boot', 'Hibernate', 'PostgreSQL'],
        code: 'https://github.com/pranshu-tomer/Bank-Backend',
        demo: 'https://voltrex-bank.netlify.app/',
        image: one
    },
    {
        id: 2,
        projectName: 'Doctor Appointment Booking System',
        projectDesc: 'A web-based application that allows patients to book doctor appointments online.',
        tags: ['React', 'Node.js', 'Express', 'MongoDB'],
        code: 'https://github.com/pranshu-tomer/Prescripto',
        demo: 'https://dockit.netlify.app/',
        image: two
    },
    {
        id: 3,
        projectName: 'Resume Builder',
        projectDesc: "A React-based Resume Builder that allows users to create and customize their resumes with ease.",
        tags: ['React', 'Redux', 'Clerk.js'],
        code: 'https://github.com/pranshu-tomer/ResumeBuilder',
        demo: 'https://pranshu-tomer-sv-resume-builder.netlify.app/',
        image: four
    },
    {
        id: 4,
        projectName: 'Algorithm Visualizer',
        projectDesc: 'A web-based tool that visualizes various algorithms and data structures in action.',
        tags: ['React', 'JavaScript'],
        code: 'https://github.com/pranshu-tomer/Algorithms',
        demo: 'https://struct-view.netlify.app/',
        image: three
    },
    {
        id: 5,
        projectName: 'WandarLust - Hotel Booking',
        projectDesc: 'A platform for hotel owners to list their properties and for travelers to find and review hotels.',
        tags: ['MERN', 'React', 'Node.js', 'Express', 'MongoDB'],
        code: 'https://github.com/pranshu-tomer/WanderLust',
        demo: 'https://wanderlust-ll2g.onrender.com',
        image: five
    },
    {
        id: 6,
        projectName: 'NIT Students Portal',
        projectDesc: 'A portal for NIT students to access resources, connect with peers, and stay updated on campus events.',
        tags: ['Node.js', 'Express', 'EJS', 'MongoDB'],
        code: 'https://github.com/pranshu-tomer/nit-students',
        demo: 'https://nit-students-sv.onrender.com',
        image: six
    },
    {
        id: 7,
        projectName: 'Digital Agriculture',
        projectDesc: "Predict Disease in plants using image processing and deep learning techniques to help farmers identify and manage crop diseases effectively.",
        tags: ['Python', 'TensorFlow', 'CNN','Machine Learning'],
        code: 'https://github.com/pranshu-tomer/Bluelock',
        demo: '',
        image: seven
    },
    {
        id: 8,
        projectName: 'Laptop Price Predictor',
        projectDesc: 'Based on machine learning.It predict the Laptop price according to its specifications like RAM,size and storage etc.',
        tags: ['Python', 'Machine Learning','matplotlib'],
        code: 'https://github.com/pranshu-tomer/laptop-price-predictor',
        demo: '',
        image: eight
    },
    {
        id: 9,
        projectName: 'TodoList-React',
        projectDesc: "It might sound basic, but it's been quite fun and educational. For state management , I used contextAPI. I used a hook called useEffect to set and get the items in localStorage.",
        tags: ['React', 'CSS'],
        code: 'https://github.com/pranshu-tomer/todo-list-react',
        demo: 'https://shadow-voltrex-todo-list.netlify.app/',
        image: one
    },
    {
        id: 10,
        projectName: 'Fruit Predictor',
        projectDesc: 'Based on machine learning.It predict the fruit name according to its physical appearance like color,weight and size etc.',
        tags: ['Python', 'Machine Learning'],
        code: 'https://github.com/pranshu-tomer/fruit-predictor',
        demo: '',
        image: two
    },
    {
        id: 11,
        projectName: 'Simon Game',
        projectDesc: 'JavaScript-based project: the Simon Says game. With four color boxes, players must remember and repeat the sequence of blinking colors. Each level adds a new blinking color, challenging players to recall the sequence accurately. Test your memory and reflexes with Simon Says!',
        tags: ['JavaScript', 'HTML', 'CSS'],
        code: 'https://github.com/pranshu-tomer/javaScript-project',
        demo: 'https://guileless-sprite-6827eb.netlify.app/',
        image: three
    },
    {
        id: 12,
        projectName: 'Number Guess Game',
        projectDesc: 'This project is purely based on JavaScript.Game is about guessing the random number.',
        tags: ['JavaScript', 'HTML', 'CSS'],
        code: 'https://github.com/pranshu-tomer/guessNumber-game',
        demo: 'https://shadow-voltrex-guess-number.netlify.app/',
        image: four
    },
    {
        id: 13,
        projectName: 'UsabilityHub Clone',
        projectDesc: 'A frontend replica of the UsabilityHub site! I put it together while mastering HTML and CSS on my journey to becoming a full-stack developer. But keep in mind, my version isn\'t responsive yet.',
        tags: ['HTML', 'CSS', 'JavaScript'],
        code: 'https://github.com/pranshu-tomer/UsabilityHub---Clone',
        demo: 'https://mellow-bombolone-6a0655.netlify.app/',
        image: five
    },
    {
        id: 14,
        projectName: 'Password Generator',
        projectDesc: 'This project is based on ReactJs.  You can create password of diffrent length.',
        tags: ['React', 'CSS'],
        code: 'https://github.com/pranshu-tomer/passwordGenerator-react',
        demo: 'https://shadow-voltrex-password-generator.netlify.app/',
        image: six
    },
    {
        id: 15,
        projectName: 'FrontEnd',
        projectDesc: 'A sleek side navigation bar implementation. Mini frontend project , just for Fun',
        tags: ['HTML', 'CSS', 'JavaScript'],
        code: 'https://github.com/pranshu-tomer/Mini-Project-html-css',
        demo: 'https://phenomenal-nougat-2c14ff.netlify.app/',
        image: seven
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/